import React from 'react';
import i18next from 'i18next';
import MediaQuery from 'react-responsive';
import {connect, Provider} from 'react-redux';
import {Route, Switch, withRouter} from 'react-router-dom';
import {createHashHistory} from 'history';
import {applyMiddleware, compose, createStore} from 'redux';
import {
    ConnectedRouter,
    connectRouter,
    routerMiddleware,
} from 'connected-react-router';
import rootReducer from './reducers';
import {crashWs} from './websocketController';
import Api from './api';
import {hideMenu} from './actions/appActions';
import {
    setBalance,
    setGuest,
    setProfile,
    setWallets,
} from './actions/userActions';

import GameNav from './components/GameNav/GameNav';
import CrashGame from './components/CrashGame/CrashGame';
import SlotsGame from './components/SlotsGame/SlotsGame';
import EsportsGame from './components/EsportsGame/EsportsGame';
import Sidebar from './components/Sidebar/Sidebar';
import Header from './components/Header/Header';
import StaticPage from './components/StaticPage/StaticPage';
import Refs from './components/Refs/Refs';
import Profile from './components/Profile/Profile';
import WalletPage from './components/Wallet/WalletPage';
import {
    ModalsConsumer,
    ModalsProvider,
} from './components/Modal/ModalsProvider';
import Panel from './components/Panel/Panel';
import SwipeableChat from './components/Chat/SwipeableChat';
import {SingleResetPasswordForm} from './components/Form/ResetPasswordForm';
import AdultControl from './components/AdultControl/AdultControl';
import couponManager from './couponManager';
import {AnimatePresence, motion} from 'framer-motion';

import RightSidebar from './components/RightSidebar/RightSidebar';
import TwitchPlayerStandalone from './components/TwitchPlayer/TwitchPlayerStandalone';
import UI from './components/UI/UI';

import ru from '../locales/ru.json';
import en from '../locales/en.json';

window.i18next = i18next;

const history = createHashHistory();
const appliedRouterMiddleware = routerMiddleware(history);

const locales = {
    ru,
    en,
};


const store = createStore(
    connectRouter(history)(rootReducer),
    {},
    compose(
        applyMiddleware(appliedRouterMiddleware),
        process.env.NODE_ENV !== 'production' && window.devToolsExtension
            ? window.devToolsExtension()
            : (f) => f
    )
);


couponManager.init(store.getState, store.dispatch);

const UPDATE_BALANCE_PERIOD = 2000;

class AppContent extends React.Component {
    constructor(props) {
        super(props);

        crashWs.init({
            store,
            channel: '/crash_sc',
            onOpen: this.sendCurrentPathname,
        });
        chatWs.init({store, channel: '/chat_sc'});

        this.balanceTimer = null;
    }

    componentWillMount() {
//const languag = 'en';
        const language = window.navigator ? (window.navigator.language ||
            window.navigator.systemLanguage ||
            window.navigator.userLanguage) : "ru";
        const languag = language.substr(0, 2).toLowerCase();
        console.log(languag === 'ru' ? 'ru' : 'en')
        this.setLanguage(languag === 'ru' ? 'ru' : 'en');
    }


    componentWillUnmount() {
        clearTimeout(this.balanceTimer);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.props.hideMenu();
        }

        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.sendCurrentPathname();
        }
    }

    componentDidMount() {
        Api.profile().then((response) => {
            if (response.profile) {
                this.onIfAuth(response.profile);
            } else {
                this.onIfNotAuth();
            }
        });
    }

    onIfAuth(userInfo) {
        store.dispatch(setProfile(userInfo));
        this.updateBalance();
        this.fetchWallets();
    }

    onIfNotAuth() {
        store.dispatch(setGuest());
    }

    updateBalance = () => {
        clearTimeout(this.balanceTimer);

        Api.balance().then((response) => {
            store.dispatch(setBalance(response.balance, response.balance_cash));

            this.balanceTimer = setTimeout(this.updateBalance, UPDATE_BALANCE_PERIOD);
        });
    };

    fetchWallets = () => {
        Api.wallets().then((response) => {
            store.dispatch(setWallets(response.data));
        });
    };

    setLanguage(language) {
        i18next.init({
            lng: language,
            resources: locales[language],
        });

        document.body.setAttribute('data-lang', language);
    }

    sendCurrentPathname = () => {
        window.crashWs.send(
            JSON.stringify({
                action: 'location_changed',
                pathname: this.props.location.pathname,
            })
        );


        window.chatWs.send(
            JSON.stringify({
                action: 'location_changed',
                pathname: this.props.location.pathname,
            })
        );
    };


    render() {
        const variants = {
            initial: {opacity: 0, x: -50},
            enter: {opacity: 1, x: 0},
            exit: {opacity: 0},
        };

        const {slotsEnabled} = this.props;

        return (
            <ModalsProvider>
                {this.props.isLoading ? (
                    <div className="app__loader">{i18next.t('loading')}</div>
                ) : null}
                <Header/>
                <AdultControl/>
                <TwitchPlayerStandalone/>
                <MediaQuery query="(max-width: 960px)">
                    {this.props.signedIn && <SwipeableChat/>}
                </MediaQuery>

                <div className="app">
                    <MediaQuery query="(min-width: 960px)">
                        <div className="app__side">
                            <Sidebar/>
                        </div>
                    </MediaQuery>
                    <div className="app__main">
                        <div className="app__top">
                            <GameNav slotsEnabled={slotsEnabled}/>
                        </div>
                        <ModalsConsumer>
                            {({showModal}) => (
                                <div className="app__game">
                                    <Route
                                        render={({location}) => (
                                            <AnimatePresence exitBeforeEnter initial={false}>
                                                <Switch location={location} key={location.pathname}>
                                                    {/* <Route exact path="/ui" render={ (props) => (
                          <motion.div variants={ variants } initial="initial" animate="enter" exit="exit">
                            <UI { ...props }/>
                          </motion.div>
                        ) }/> */}
                                                    <Route
                                                        exact
                                                        path="/"
                                                        render={(props) => (
                                                            <motion.div
                                                                variants={variants}
                                                                initial="initial"
                                                                animate="enter"
                                                                exit="exit"
                                                            >
                                                                <CrashGame {...props} />
                                                            </motion.div>
                                                        )}
                                                    />
                                                    {slotsEnabled && (
                                                        <Route
                                                            exact
                                                            path="/slots"
                                                            render={(props) => (
                                                                <motion.div
                                                                    variants={variants}
                                                                    initial="initial"
                                                                    animate="enter"
                                                                    exit="exit"
                                                                >
                                                                    <SlotsGame {...props} showModal={showModal}/>
                                                                </motion.div>
                                                            )}
                                                        />
                                                    )}
                                                    <Route
                                                        exact
                                                        path="/terms"
                                                        render={(props) => (
                                                            <motion.div
                                                                variants={variants}
                                                                initial="initial"
                                                                animate="enter"
                                                                exit="exit"
                                                            >
                                                                <StaticPage {...props} />
                                                            </motion.div>
                                                        )}
                                                    />
                                                    <Route
                                                        exact
                                                        path="/rules"
                                                        render={(props) => (
                                                            <motion.div
                                                                variants={variants}
                                                                initial="initial"
                                                                animate="enter"
                                                                exit="exit"
                                                            >
                                                                <StaticPage {...props} />
                                                            </motion.div>
                                                        )}
                                                    />
                                                    <Route
                                                        exact
                                                        path="/faq"
                                                        render={(props) => (
                                                            <motion.div
                                                                variants={variants}
                                                                initial="initial"
                                                                animate="enter"
                                                                exit="exit"
                                                            >
                                                                <StaticPage {...props} />
                                                            </motion.div>
                                                        )}
                                                    />
                                                    <Route
                                                        exact
                                                        path={['/wallet', '/wallet/:activeForm']}
                                                        render={(props) => (
                                                            <motion.div
                                                                variants={variants}
                                                                initial="initial"
                                                                animate="enter"
                                                                exit="exit"
                                                            >
                                                                <WalletPage {...props} />
                                                            </motion.div>
                                                        )}
                                                    />
                                                    <Route
                                                        exact
                                                        path="/reset-password/:resetKey"
                                                        render={(props) => (
                                                            <motion.div
                                                                variants={variants}
                                                                initial="initial"
                                                                animate="enter"
                                                                exit="exit"
                                                            >
                                                                <SingleResetPasswordForm {...props} />
                                                            </motion.div>
                                                        )}
                                                    />
                                                    <Route
                                                        path="/esports"
                                                        render={(props) => (
                                                            <motion.div
                                                                variants={variants}
                                                                initial="initial"
                                                                animate="enter"
                                                                exit="exit"
                                                            >
                                                                <EsportsGame {...props} />
                                                            </motion.div>
                                                        )}
                                                    />
                                                </Switch>
                                            </AnimatePresence>
                                        )}
                                    />
                                </div>
                            )}
                        </ModalsConsumer>
                        {this.props.signedIn && (
                            <MediaQuery query="(max-width: 959px)" className="app__bottom">
                                <Panel title={i18next.t('profile')}>
                                    <Profile/>
                                </Panel>
                                <Panel title={i18next.t('blocks.refs')}>
                                    <Refs/>
                                </Panel>
                            </MediaQuery>
                        )}
                    </div>
                    <RightSidebar/>
                </div>
            </ModalsProvider>
        );
    }
}

const ConnectedAppContent = connect(
    (state) => {
        return {
            isLoading: state.user.isLoading,
            signedIn: !!state.user.profile,
            slotsEnabled: state.user.profile.slots,
        };
    },
    {
        hideMenu,
    }
)(AppContent);

class App extends React.Component {
    render() {
        const AppContent = withRouter(ConnectedAppContent);

        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <AppContent/>
                </ConnectedRouter>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./app/App.jsx